export default "__VITE_ASSET__pUjePzwu__"